module.exports = __webpack_public_path__ + "img/icon-mytarget.fc6cea37.svg";